











































import { mapGetters, mapMutations } from 'vuex'
import { RouteNames } from '@/router'
import CardOptionVue from '@/components/SchemeCard/CardOption.vue'
import CardOptionBadge from '@/components/CardOptionBadge/CardOptionBadge.vue'
import CardQuickOptions from '@/components/CardQuickOptions/CardQuickOptions.vue'
import { SchemeAction } from '@/store/modules/scheme/actions'
import { _SCHEME__CURRENT_TEST } from '@/store/mutations'
import SchemeCommon from '@/abstract/SchemeCommon'
import { MAX_OPTIONS_COUNT } from '@/constants/scripts'

import type { RawLocation } from 'vue-router'
import type { SchemeCurrentTestPayload } from '@/store/modules/scripts/mutations'
import type { CardOption, SchemeCardContent, SchemeCardInfo } from '@/models/scripts'
import type { CardVariant } from '@/constants/scripts'

interface Methods {
  [_SCHEME__CURRENT_TEST]: (payload: SchemeCurrentTestPayload) => void
  handleToggleQuickOption: (isOpen: boolean) => void
}

interface Computed {
  getSchemeUpdate: number
  isEdit: boolean
  cardNumberId: string
  cardContainerId: string
  scriptId: string
  instanceId: string | undefined
  cardClickRoute: RawLocation
  cardTestName: string
  current: CardVariant
  content: SchemeCardContent | undefined
  contentOptions: CardOption[]
  cardStyles: Record<string, string>
  numBgColor: Record<string, string>
  canCreateOption: boolean
}

interface Props {
  card: SchemeCardInfo
  zoom: number
}

export default SchemeCommon.extend<{}, Methods, Computed, Props>({
  components: {
    CardOptionVue,
    CardOptionBadge,
    CardQuickOptions,
  },
  props: {
    card: {
      required: true,
    },
    zoom: {
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getSchemeUpdate']),
    isEdit(): boolean {
      return this.$route.name === RouteNames.ScriptSchemeEdit
    },
    cardNumberId(): string {
      return `card-num-${this.card.num}`
    },
    cardContainerId(): string {
      return `card-container-${this.card.num}`
    },
    scriptId(): string {
      return this.$route.params.scriptId
    },
    instanceId(): string | undefined {
      return this.$route.params.instanceId
    },
    cardClickRoute(): RawLocation {
      const { scriptId, instanceId, card } = this

      if (this.isEdit) {
        return {
          name: RouteNames.ScriptEdit,
          params: { scriptId, cardId: card.id },
        }
      }

      return {
        name: RouteNames.ScriptPage,
        params: { scriptId, instanceId: instanceId as string },
        query: { startCardNum: `${this.card.num}` },
      }
    },
    cardTestName(): string {
      if (this.card.ab) {
        return `test-${this.card.id}`
      }
      return 'test'
    },
    current: {
      get(): CardVariant {
        return this.card.current
      },
      set(_value: CardVariant) {
        this[_SCHEME__CURRENT_TEST]({
          cardId: this.card.id,
          current: _value,
        })
        this.updateScheme()
      },
    },
    content(): SchemeCardContent | undefined {
      return this.card.content[this.current]
    },
    contentOptions(): CardOption[] {
      return this.content?.options || []
    },
    cardStyles(): Record<string, string> {
      const wide = this.content !== undefined ? this.content.wide + 1 : 0
      const deep = this.content !== undefined ? this.content.deep + 1 : 0
      const row = this.content !== undefined ? this.content.row + 1 : 0
      return {
        gridColumn: `${deep}`,
        gridRow: `${row} / span ${wide}`,
      }
    },
    numBgColor(): Record<string, string> {
      const backgroundColor = this.card.color || '5e45b5'
      return {
        backgroundColor: `#${backgroundColor}`,
      }
    },
    canCreateOption(): boolean {
      return this.isEdit && !!this.instanceId && this.contentOptions.length < MAX_OPTIONS_COUNT
    }
  },
  methods: {
    ...mapMutations([_SCHEME__CURRENT_TEST]),
    handleToggleQuickOption(isOpen: boolean): void {
      this.$store.dispatch(SchemeAction.SetBackgrounded, isOpen)
    }
  },
})
